(() => {
  const legacyHashes = new Set(['#build-enquiry-form', '#shopify-section-template--26641869603157__custom_liquid_wdwczJ']);
  const destination = '/pages/project-enquiry';
  const redirectLegacy = () => {
    if (window.Shopify && window.Shopify.designMode) return;
    if (!legacyHashes.has(window.location.hash) || window.location.pathname === destination) return;
    const target = new URL(destination, window.location.origin);
    target.search = window.location.search;
    window.location.replace(target.href);
  };
  redirectLegacy();
  window.addEventListener('hashchange', redirectLegacy);
  const updateLink = (link) => {
    if (!link || !link.hasAttribute('href')) return;
    try {
      const url = new URL(link.getAttribute('href'), window.location.href);
      if (['irishsaunacompany.com', 'www.irishsaunacompany.com', 'xyku2s-wp.myshopify.com'].includes(url.hostname) && legacyHashes.has(url.hash)) {
        link.setAttribute('href', destination);
      }
    } catch {}
  };
  const updateLinks = () => document.querySelectorAll('a[href]').forEach(updateLink);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateLinks, { once: true });
  else updateLinks();
  for (const eventName of ['click', 'auxclick', 'focusin', 'pointerover']) {
    document.addEventListener(eventName, event => updateLink(event.target.closest?.('a[href]')), true);
  }
})();